import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import FormHandler from "../../shared/utils/FormHandler";
import FeatherIcon from "feather-icons-react";
import {useTranslation} from "react-i18next";
import {createAccountUser, updateAccountUser} from "../../utils/mainServices";
import {toast} from "react-toastify";
import {toggleLoader} from "../../shared/actions/setting"; 
import { validateAccountForm } from "../../utils/validation";

const FormAccount = ({selectedAccount, onClose, formType}) => {
  const dispatch = useDispatch();
  const {t} = useTranslation();
  const [formErr, setFormErr] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  

  const {
    values,
    errors,
    handleSubmit,
    handleChange,
    handleOnBlur,
    initForm,
  } = FormHandler(formDetails, validateAccountForm);

  function formDetails() {
    setIsLoading(true);
  }

  // Initialize form when the modal is opened
  useEffect(() => { 
    initForm({
      name: selectedAccount?.name || "",
      contactName: selectedAccount?.contactName || "",
      contactEmail: selectedAccount?.contactEmail || "",
      contactAddress: selectedAccount?.contactAddress || "",
      contactPhoneNumber: selectedAccount?.contactPhoneNumber || "",
    });       
  }, [selectedAccount]);

  const resetForm = (state) => {
    onClose(state);
    initForm({});
    setFormErr("");
  };

 //update the account details
  useEffect(() => {
    if ( formType === "edit") {
      const updateAccountDetails = async () => {
        dispatch(toggleLoader(true));
        try {        
          values.id = selectedAccount.id;
          await updateAccountUser(values, selectedAccount.id);
          resetForm(true);
          toast.success("Account details updated successfully");
        } catch (error) {
          console.error("Error updating Account details:", error);
          toast.error("Failed to update Account details");
        } finally {
          dispatch(toggleLoader(false));
          setIsLoading(false);
        }
      };
    
      if (isLoading) {
        updateAccountDetails();
      }
    } else {
      const createAccountDetails = async () => {
            dispatch(toggleLoader(true));
            console.log(values)
            try {        
              await createAccountUser(values);
              resetForm(true);
              toast.success("Account created successfully");
            } catch (error) {
              console.error("Error create Account:", error);
              toast.error("Failed to create Account");
            } finally {
              dispatch(toggleLoader(false));
              setIsLoading(false);
            }
          };
        
          if (isLoading) {
            createAccountDetails();
          }
    }
  }, [isLoading]);
  
  

  return (
    <div className={`sa-popup-bg`}>
      <div className="sa-popup">
        <form onSubmit={handleSubmit} className="sa-modal-box-style" noValidate>
          <div className="sa-popup-header">
            <span className="sa-model-heading">{t(formType === "add" ? "title.CREATE_ACCOUNT" : "title.EDIT_ACCOUNT")} </span>
            <div className="sa-popup-close-icon"  onClick={() => resetForm(false)}>
              <FeatherIcon className="sa-modal-close-icon" icon="x"/>
            </div>
          </div>
          <div className="sa-popup-content">
              <div className="col-md-6">
               <div className="form-group m-b-16">
                  <label htmlFor="name">Name</label>
                  <input
                     type="text"
                     className={`form-control ${errors.name && "warning-input"}`}
                     onBlur={handleOnBlur}
                     onChange={handleChange}
                     value={values.name || ""}
                     name="name"
                     id="name"
                     placeholder="Enter Account name"
                  />
                  {errors.name && <p className="warning-input-msg">{errors.name}</p>}
               </div>
              </div>
              <div className="col-md-6">
               <div className="form-group m-b-16">
                  <label htmlFor="contactName">Contact Name</label>
                  <input
                     type="text"
                     className={`form-control ${errors.contactName && "warning-input"}`}
                     onBlur={handleOnBlur}
                     onChange={handleChange}
                     value={values.contactName || ""}
                     name="contactName"
                     id="contactName"
                     placeholder="Enter Contact Name"
                  />
                  {errors.contactName && <p className="warning-input-msg">{errors.contactName}</p>}
               </div>
              </div>
              <div className="col-md-6">
               <div className="form-group m-b-16">
                  <label htmlFor="contactEmail">Contact Email</label>
                  <input
                     type="text"
                     className={`form-control ${errors.contactEmail && "warning-input"}`}
                     onBlur={handleOnBlur}
                     onChange={handleChange}
                     value={values.contactEmail || ""}
                     name="contactEmail"
                     id="contactEmail"
                     placeholder="Enter Contact Email"
                  />
                  {errors.contactEmail && <p className="warning-input-msg">{errors.contactEmail}</p>}
               </div>
              </div>
              <div className="col-md-6">
               <div className="form-group m-b-16">
                  <label htmlFor="contactPhoneNumber">Contact Phone Number</label>
                  <input
                     type="text"
                     className={`form-control ${errors.contactPhoneNumber && "warning-input"}`}
                     onBlur={handleOnBlur}
                     onChange={handleChange}
                     value={values.contactPhoneNumber || ""}
                     name="contactPhoneNumber"
                     id="contactPhoneNumber"
                     placeholder="Enter Contact Phone Number"
                  />
                  {errors.contactPhoneNumber && <p className="warning-input-msg">{errors.contactPhoneNumber}</p>}
               </div>
              </div>             
            </div>
          {formErr && <div className="login-warning-msg">{formErr}</div>}
          <div className="sa-popup-btn" style={{display: "flex", justifyContent: "flex-end"}}>
          <button type="submit" className="sa-popup-secondary-btn-style">
            {t(formType === "add" ? "button.CREATE" : "button.UPDATE")}
          </button>         
          </div>
        </form>
      </div>
    </div>
  );
};

export default FormAccount;